import { CategoryFieldName } from '@infotech-soe/metaschema';

import {
  TDatasetTotalsConfigFront,
  TOTALS_FORMULA_ATTACHMENT,
  TOTALS_FORMULA_TYPE,
  TotalsRuleFront,
} from '../../models/user-config/DisplayModeConfig';

export class TotalsConfigSanitizer {
  private readonly ALLOWED_TOTALS_FORMULAS_DICT = [
    TOTALS_FORMULA_TYPE.AVG,
    TOTALS_FORMULA_TYPE.MAX,
    TOTALS_FORMULA_TYPE.MIN,
    TOTALS_FORMULA_TYPE.SUM,
  ];
  private readonly ALLOWED_TOTALS_ATTACHMENT_DICT = [
    TOTALS_FORMULA_ATTACHMENT.ALL,
    TOTALS_FORMULA_ATTACHMENT.SELECTED,
  ];

  private readonly isValidFormula = (formula: unknown) =>
    this.ALLOWED_TOTALS_FORMULAS_DICT.includes(formula as TOTALS_FORMULA_TYPE);
  private readonly isValidAttachment = (attachment: unknown) =>
    this.ALLOWED_TOTALS_ATTACHMENT_DICT.includes(
      attachment as TOTALS_FORMULA_ATTACHMENT
    );
  private readonly isTotalValid = ([
    ,
    formula,
    attachment,
  ]: TotalsRuleFront): boolean =>
    this.isValidFormula(formula) && this.isValidAttachment(attachment);

  constructor(
    private readonly totals: TDatasetTotalsConfigFront | undefined,
    private readonly allowedFields: CategoryFieldName[]
  ) {}

  public getCleanedConfig = (): TDatasetTotalsConfigFront | undefined => {
    if (!this.totals) return;
    const totalsEntries = Object.entries(this.totals);
    const validTotalsEntries = totalsEntries
      .filter(([field]) => this.allowedFields.includes(field))
      .map(([field, total]) => [field, total.filter(this.isTotalValid)]);

    return validTotalsEntries.length
      ? Object.fromEntries(validTotalsEntries)
      : undefined;
  };
}
